import httpCommon from 'src/http-common';
import CLIENT_CONFIG from './core-config';
import { storage } from 'src/utils/storage';

const DEFAULT_CLIENT = 'WEBWORK_STANDARD';
const STORAGE_KEY = 'activeClient';

// Map site code to client config key
const mapToClientKey = (siteCd) => {
  if (!siteCd) return DEFAULT_CLIENT;
  if (CLIENT_CONFIG[siteCd]) return siteCd;
  
  const upper = siteCd.toUpperCase();
  if (upper.includes('SMCD')) return 'SMCD_CUSTOMIZATION';
  if (upper.includes('VISB')) return 'VERMI_CUSTOMIZATION';
  
  return DEFAULT_CLIENT;
};

// Fetch and set active client after login
export const fetchDefaultSiteCode = async () => {
  try {
    const loginId = storage.get('loginId');
    if (!loginId) {
      localStorage.setItem(STORAGE_KEY, DEFAULT_CLIENT);
      return DEFAULT_CLIENT;
    }
      
    const response = await httpCommon.get(`/get_auto_select_default_site_code.php?login_id=${loginId}`);
    
    if (response.data.status === 'SUCCESS') {

      const siteCd = response.data.data[0]?.default_site;
      if (siteCd) {
        const clientKey = mapToClientKey(siteCd);
        localStorage.setItem(STORAGE_KEY, clientKey);
        console.log('Active client set to:', clientKey);
        return clientKey;
      }
    }
    
    localStorage.setItem(STORAGE_KEY, DEFAULT_CLIENT);
    return DEFAULT_CLIENT;
  } catch (error) {
    console.log('yyy5', error);
    console.error('Error fetching default site code:', error);
    localStorage.setItem(STORAGE_KEY, DEFAULT_CLIENT);
    return DEFAULT_CLIENT;
  }
};

// Get current client config
export const getClientConfig = () => {
  const clientKey = localStorage.getItem(STORAGE_KEY) || DEFAULT_CLIENT;
  return CLIENT_CONFIG[clientKey] || CLIENT_CONFIG[DEFAULT_CLIENT];
};

// Get active client key
export const getActiveClient = () => {
  return localStorage.getItem(STORAGE_KEY) || DEFAULT_CLIENT;
};
